export default {"src":"/_next/static/media/cdek.5312bcfc.svg","height":19,"width":69,"blurWidth":0,"blurHeight":0};